export default {"src":"/_next/static/image/public/images/ic_add_female_member.e62f2c5679cae1c9ecad5b7e6d617c6b.svg","height":141,"width":133};